<template>
  <div class="layout-grid mx-auto gap-y-24 md:gap-y-64">
    <template v-for="(article, index) in articles">
      <template v-if="largeImage(index)">
        <div
          class="layout-grid-contain md:col-span-6 md:col-start-2"
          :class="{
            'mt-[131px]': index > 0,
            'mt-[20px]': index === 0,
          }"
        >
          <p class="text-[12px] font-light uppercase text-grey-dark-02">
            {{ getOverline(article.categories) }}
          </p>
          <Text
            class="mt-16 max-w-md text-2xl font-light uppercase md:text-5xl"
            :class="{
              '!font-bold': isRebranding,
            }"
          >
            {{ article.title }}
          </Text>
          <div
            class="rich-text mt-16 max-w-md text-lg font-light leading-8 text-grey-dark-01"
            v-html="article.teaserText"
          />
          <DrupalLink
            :to="article.url?.path"
            class="link-button mt-[42px] block"
          >
            {{ $texts('readMore', 'Read more') }}
          </DrupalLink>
        </div>

        <DrupalLink
          :key="article.id"
          :to="article.url?.path"
          class="col-span-full col-start-1 mt-[27px] md:col-span-7 md:col-start-8 md:mt-0"
        >
          <MediaImage
            v-bind="article.titleImage"
            :image-style="imageStyleLarge"
            img-class="w-full"
          />
        </DrupalLink>
      </template>

      <MagazineHighlightGridTeaser
        v-else
        :key="article.id"
        :article="article"
        class="col-span-2 md:col-span-3"
        :class="{
          '!col-start-2': index % 5 === 1,
          'col-start-2 md:col-start-auto': index % 5 === 3,
        }"
        :image-style="imageStyleSmall"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { type MagazineArticleTeaserFragment } from '#graphql-operations'
import { falsy } from '~/helpers/type'

const { $texts } = useEasyTexts()
const isRebranding = await useFeatureFlag()

defineProps<{
  articles: MagazineArticleTeaserFragment[]
}>()

const getOverline = (
  categories?: MagazineArticleTeaserFragment['categories'],
) => {
  return categories
    ?.map((v) => v.label)
    .filter(falsy)
    .join(', ')
}

const largeImage = (index: number) => index % 5 === 0

const imageStyleLarge = defineImageStyle({
  type: 'sizes',
  aspectRatio: 1,
  sizes: {
    sm: 767,
    xxl: 1236,
  },
})

defineOptions({
  name: 'MagazineHighlightGridTopic',
})

const imageStyleSmall = defineImageStyle({
  type: 'pictures',
  pictures: {
    sm: {
      width: 400,
      aspectRatio: 2 / 3,
    },
    md: {
      width: 202,
      aspectRatio: 2 / 3,
    },
    lg: {
      width: 310,
      aspectRatio: 2 / 3,
    },
  },
})
</script>
